import React, { useState } from 'react'
import DonationForm from './DonationForm'
import TreeForm from '../components/TreeForm'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCreditCard, faTree } from '@fortawesome/free-solid-svg-icons'

const DonationSection = () => {
  const [donationPage, setDonationPage] = useState('generalDonation')

function handleTab(id) {
  setDonationPage(id);
}

 return (
   <>
    <div className="tabs is-centered">
      <ul>
        <li className={ donationPage === 'generalDonation' ? 'is-active' : ''}><a onClick={() => handleTab('generalDonation')} role='nav-button'>
          <FontAwesomeIcon icon={faCreditCard} style={{marginRight: '7px'}} />General Donation</a>
        </li>
        <li className={ donationPage === 'treeDonation' ? 'is-active' : ''}><a onClick={() => handleTab('treeDonation')} role='nav-button'>
          <FontAwesomeIcon icon={faTree} style={{marginRight: '5px'}} /> Tree Planting Donation</a>
        </li>
      </ul>
    </div>
    {donationPage === 'generalDonation' ? 
      <DonationForm /> : null 
    }
    {donationPage === 'treeDonation' ? 
      <TreeForm /> : null 
    }
  </>
 )
}

export default DonationSection